import React from 'react';
import ReactDOM from 'react-dom';
import './styles/bulma.css';
import './index.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));

// eslint-disable-next-line
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o), m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m) })(window,document,'script','//www.google-analytics.com/analytics.js','ga'); ga('create', 'UA-17655032-11', 'auto'); ga('send', 'pageview');


// WEBPACK FOOTER //
// ./src/index.js